import { HostListener, Component } from '@angular/core';

import {
    NavParams,
    ViewController } from 'ionic-angular';

import { SettingsService } from "../../services/settings.service";
import { Organization } from '../../model/organization';
import { SearchOptions } from '../../model/searchOptions';

@Component({
    selector: 'filter-page',
    templateUrl: 'filter-page.html'
})
export class FilterPage {
    searchOptions : SearchOptions = null;

    organizations: Organization[];
    eventTypes: string[];

    minDate: string;
    maxDate: string;

    addedMoneyOptions: any;

    popoverActive: boolean = false;
    error: boolean = false;

    constructor(navParams : NavParams, private settingsService : SettingsService, private viewController : ViewController) {
        this.searchOptions = navParams.get('searchOptions');

        this.settingsService.getSettings()
        .then(data => {
            this.organizations = (data as any).organizations;
            this.eventTypes = (data as any).eventTypes;

            for (let i = 0; i < this.searchOptions.organizations.length; i++) {
                this.searchOptions.organizations[i] = this.organizations.filter(x => x.id == this.searchOptions.organizations[i].id)[0];
            }
        });

        this.setupMinMaxDates();

        if (this.searchOptions == null || this.searchOptions == undefined) {
            this.searchOptions = new SearchOptions();
        }
    }

    setupMinMaxDates() {
        let newMinDate = new Date();
        newMinDate.setFullYear(newMinDate.getFullYear() - 2);

        this.minDate = newMinDate.toISOString();    
        
        let newMaxDate = new Date();
        newMaxDate.setFullYear(newMaxDate.getFullYear() + 1);
        newMaxDate.setDate(31);
        newMaxDate.setMonth(12);
        this.maxDate = newMaxDate.toISOString();   
    }

    orgCompare(a: { id:number }, b: { id:number }) {
        return a.id === b.id;
    }

    search() {
        this.viewController.dismiss(this.searchOptions);
    }

    cancel() {
        this.viewController.dismiss();
    }

    back() {
        this.viewController.dismiss();
    }

    reset() {
        this.searchOptions = new SearchOptions();
    }

    _bdClick() {
        return this.viewController.dismiss();
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 27 && this.viewController.isLast() && !this.popoverActive) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/filter/filter-page.ts